module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout"
  }, [_vm._v("\n  new address\n  "), _c('span', [_vm._v("上海")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.district),
      expression: "district"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.district = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "putuo"
    }
  }, [_vm._v("普陀")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "jinan"
    }
  }, [_vm._v("静安")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.street),
      expression: "street"
    }],
    attrs: {
      "type": "text",
      "placeholder": "街道门牌号"
    },
    domProps: {
      "value": (_vm.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.street = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        return _vm.saveAddress()
      }
    }
  }, [_vm._v("保存")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-b19aed8e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/NewAddress.vue
// module id = 549
// module chunks = 1